import { useQueryClient } from 'react-query';

import { IdentifierDTO, useToggle } from '@zazume/zzm-base';

import { useAsyncMethod } from '#/hooks/useAsyncMethod';
import { API } from '#lib/network/API';
import { VoPValidationResult } from '#lib/network/api/vop/vop';

import { VoPKeys } from './VoP.keys';

export const useVoPAPI = () => {
  const { call } = useAsyncMethod();
  const queryClient = useQueryClient();
  const { value: isValidating, toggle: toggleIsValidating } = useToggle(false);

  const connectRevolut = () =>
    call(async () => {
      const { url } = await API.vop.getConsentURL();
      window.location.replace(url);
    });

  const renewConsent = () =>
    call(async () => {
      const { url } = await API.vop.renewConsent();
      window.location.replace(url);
    });

  const validateOwnerAccount = async (ownerAccountId: IdentifierDTO): Promise<VoPValidationResult | undefined> => {
    let result: VoPValidationResult | undefined;
    toggleIsValidating();
    await call(async () => {
      result = await API.vop.validateOwnerAccount(ownerAccountId);
    });
    toggleIsValidating();
    return result;
  };

  const validateIban = async (iban: string, name: string): Promise<VoPValidationResult | undefined> => {
    let result: VoPValidationResult | undefined;
    toggleIsValidating();
    await call(async () => {
      result = await API.vop.validate({ iban, name });
    });
    toggleIsValidating();
    return result;
  };

  const invalidateConsentStatus = async () => {
    await queryClient.invalidateQueries(VoPKeys.consentStatus);
  };

  return {
    connectRevolut,
    renewConsent,
    validateOwnerAccount,
    validateIban,
    invalidateConsentStatus,
    isValidating
  };
};
